import { all } from 'redux-saga/effects';

import salaryperEmployeeWatcher from './salary-per-employee-saga';

export default function* rootSaga(action) {
	yield all([salaryperEmployeeWatcher(action)]);
}
